import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface Props {
  readonly count: number;
  readonly error: string | null;
  readonly isLoading: boolean;
  readonly isOpen: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
}

export const DeleteFilesDialog = ({
  count,
  error,
  isLoading,
  isOpen,
  onCancel,
  onConfirm,
}: Readonly<Props>) => (
  <Dialog
    aria-describedby="delete-files-dialog-description"
    aria-labelledby="delete-files-dialog-title"
    onClose={onCancel}
    open={isOpen}
  >
    <DialogTitle id="delete-files-dialog-title">
      Confirmation de la suppression
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="delete-files-dialog-description">
        {count > 1
          ? `Êtes-vous sûr de vouloir supprimer ces ${count.toFixed()} fichiers ? Cette action est définitive.`
          : 'Êtes-vous sûr de vouloir supprimer ce fichier ? Cette action est définitive.'}
      </DialogContentText>
      {!!error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} size="large">
        Annuler
      </Button>
      <Button
        autoFocus
        color="warning"
        loading={isLoading}
        onClick={onConfirm}
        size="large"
        variant="contained"
      >
        Supprimer
      </Button>
    </DialogActions>
  </Dialog>
);
